











import {Component, Emit, Model, Prop, Vue} from "vue-property-decorator";
@Component({
    name: "AInputCustom"
})
export default class extends Vue {
    @Prop({ type: String, default: "Nhập đầu vào" }) readonly placeholder!: string;
    @Prop({ default: 'default' }) readonly size!: string;
    @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
    @Model('change') readonly val;
    @Emit('change')
    handleChangeVal(val: any) {
        return val;
    }

    @Emit("enter")
    onEnter(evt: any) {
        return evt;
    }

    set valTrue(val: any) {
        this.handleChangeVal(val);
    }

    get valTrue() {
        return this.val;
    }
}
